// import React, { useCallback, useEffect, useState } from "react";
// import { useSocket } from "../context/SocketProvider";
// import { useNavigate } from "react-router-dom";

// const LobbyScreen = () => {
//     const [username, setUsername] = useState("");
//     const [room, setRoom] = useState("");

//     const socket = useSocket();
//     const navigate = useNavigate();

//     const handleSubmitForm = useCallback(
//         (e) => {
//             e.preventDefault();
//             socket.emit("room:join", { username, room });
//         },
//         [username, room, socket]
//     );

//     const handleJoinRoom = useCallback(
//         (data) => {
//             const { room } = data;
//             navigate(`/room/${room}`);
//         },
//         [navigate]
//     );

//     useEffect(() => {
//         socket.on("room:join", handleJoinRoom);

//         return () => {
//             socket.off("room:join", handleJoinRoom);
//         };
//     }, [socket, handleJoinRoom]);

//     return (
//         <div>
//             <h1>Lobby</h1>
//             <form onSubmit={handleSubmitForm}>
//                 <label htmlFor="username">Username</label>
//                 <input
//                     type="text"
//                     id="username"
//                     value={username}
//                     onChange={(e) => setUsername(e.target.value)}
//                 />
//                 <br /><br />
//                 <label htmlFor="room">Room ID</label>
//                 <input
//                     type="text"
//                     id="room"
//                     value={room}
//                     onChange={(e) => setRoom(e.target.value)}
//                 />
//                 <br /><br />
//                 <button>Join</button>
//             </form>
//         </div>
//     );
// };

// export default LobbyScreen;

import React, { useCallback, useEffect, useState } from "react";
import { useSocket } from "../context/SocketProvider";
import { useNavigate } from "react-router-dom";

const LobbyScreen = () => {
  const [username, setUsername] = useState("");
  const [room, setRoom] = useState("");

  const { socket, isConnected } = useSocket();
  const navigate = useNavigate();

  const handleSubmitForm = useCallback(
    (e) => {
      e.preventDefault();

      if (!socket || !isConnected) {
        console.warn("⚠️ Socket not connected yet");
        return;
      }

      socket.emit("room:join", {
        roomId: room,
        userId: username,
        userType: "guest",
        username
      });
    },
    [username, room, socket, isConnected]
  );

  useEffect(() => {
    if (!socket) return;

    const handleJoinRoom = ({ roomId }) => {
      navigate(`/room/${roomId}?userId=${username}&userType=guest`);
    };

    socket.on("room:join", handleJoinRoom);

    return () => {
      socket.off("room:join", handleJoinRoom);
    };
  }, [socket, navigate, username]);

  return (
    <div className="container d-flex flex-column justify-content-center align-items-center vh-100 bg-dark text-light">
      <h1 className="mb-4">Video Calling App</h1>

      <form onSubmit={handleSubmitForm} className="d-flex flex-column gap-3 w-50">
        <input
          type="text"
          placeholder="Enter Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          className="form-control form-control-lg"
          required
        />

        <input
          type="text"
          placeholder="Enter Room ID"
          value={room}
          onChange={(e) => setRoom(e.target.value)}
          className="form-control form-control-lg"
          required
        />

        <button
          type="submit"
          className="btn btn-primary btn-lg"
          disabled={!isConnected}
        >
          {isConnected ? "Join Room" : "Connecting..."}
        </button>
      </form>
    </div>
  );
};

export default LobbyScreen;
